import { render, staticRenderFns } from "./CompanySub.vue?vue&type=template&id=48e69fe0&scoped=true&"
import script from "./CompanySub.vue?vue&type=script&lang=js&"
export * from "./CompanySub.vue?vue&type=script&lang=js&"
import style0 from "./CompanySub.vue?vue&type=style&index=0&id=48e69fe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-lo_8cdfb8a30e6790701421bf10ca45d28a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e69fe0",
  null
  
)

export default component.exports